<template>
    <div>
        <h1>Your Carbon Footprint</h1>
        <ul id="calculatedValues">
            <li class="calculated-item" id="calcCo2">
                <div class="calculated-icon">
                    <i class="fas fa-cloud"></i>
                    <div class="co2-overlay">CO2</div>
                    <div class="icon-caption" v-if="calculations_done"><span class="calc-value">{{Math.round(lbsCo2)}}</span> LBS</div>
                    <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                </div>
            </li>
            <li class="calculated-item" id="calcOffsetCost">
                <div class="calculated-icon">
                    <i class="fas fa-tree"></i>
                    <div class="icon-caption" v-if="calculations_done"><span class="calc-value">{{Math.round(trees)}}</span> Trees</div>
                    <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                </div>
            </li>
        </ul>
        <div id="calculatedOffsetCostWrap" ref="offsetCostWrap" :style="{transform: 'scale(' + getOffsetCostWrapScale() + ')'}">
            <div class="calculated-icon" ref="offsetCostIcon">
                <div id="calculatedOffsetIcon"><i class="fas fa-cloud"></i>
                    <div class="dollar-overlay">$</div>
                </div>
            </div>
            <div id="calculatedOffsetCost" ref="offsetCostText">
                <div id="calculatedOffsetTotal" v-if="calculations_done">${{roundToDecimal(offsetCost, 2).toFixed(2)}}</div>
                <div class="icon-caption" v-if="!calculations_done"><i class="fas fa-spinner fa-spin"></i></div>
                <div id="calculatedOffsetSubtitle">Total Offset Cost</div>
            </div>
        </div>
        <div id="AboutButton">
            <a href="https://nicc-tico2e.getresponsesite.com/" target="_blank" class="button-submit"><span><span class="title"><img
                src="../../assets/NICC-_Favicon-White.png" alt="" class="nicc-icon"> Read More About</span> The National Indian Carbon Coalition's Forest Carbon Projects</span></a>
        </div>

        <!--        <project-select :project="formProject" @project-change="formProject = $event"></project-select>-->
        <payment-box :payment="offsetCost" :callback="paymentCompleted"></payment-box>
        <sponsor-info v-if="this.event && this.event.sponsor" :name="event.sponsor.name" :message="event.sponsor.message" :logo="event.sponsor.logo"></sponsor-info>
    </div>
</template>

<script>
    // import Vuex from "vuex";
    import axios from "axios";
    import SponsorInfo from "../SponsorInfo";
    import PaymentBox from "../PaymentBox";
    import ProjectSelect from "../form-elements/ProjectSelect";
    import formatting from "../../mixins/formatting";

    export default {
        name: "GeneralLivingContribute",
        components: {SponsorInfo, PaymentBox, ProjectSelect},
        mixins: [formatting],
        data() {
            return {
                projectList: {},
                event: {},
                calculations_done: false
            };
        },
        computed: {
            formProject: {
                get() {
                    return this.$store.getters["generalLivingFormData/project"];
                },
                set(value) {
                    this.$store.commit("generalLivingFormData/setProject", value);
                }
            },
            lbsCo2() {
                return this.$store.getters["generalLivingFormData/total_lbs_co2"];
            },
            trees() {
                return this.$store.getters["generalLivingFormData/trees"];
            },
            offsetCost() {
                return this.$store.getters["generalLivingFormData/total_mt_co2"] * 17.16;
            }
        },
        mounted() {
            if (!this.$store.getters["generalLivingFormData/isset"]) {
                console.log(this.$store.getters["generalLivingFormData/isset"]);
                this.$router.push("/");
                return;
            }
            this.setup();
        },
        watch: {
            "$route": function(to, from) {
                if (!this.$store.getters["generalLivingFormData/isset"]) {
                    this.$router.push("/");
                    return;
                }
                this.setup();
            }
        },
        methods: {
            projectChange(e) {
                console.log(e);
            },
            async paymentCompleted(e, fName, lName, email, anon) {
                console.log("Payment complete. Object returned:");
                console.log(e);
                if (e.state !== "approved") {
                    this.showError = true;
                    return;
                }
                console.log("Payment succeeded");
                let options = {
                    email: email,
                    first_name: fName,
                    last_name: lName,
                    project_id: this.formProject.id,
                    amount: parseFloat(e.transactions[0].amount.total),
                    anon: anon,
                    kwh: this.$store.getters["generalLivingFormData/electricity"],
                    natural_gas: this.$store.getters["generalLivingFormData/natural_gas"],
                    propane: this.$store.getters["generalLivingFormData/propane"],
                    fuel_oil: this.$store.getters["generalLivingFormData/fuel_oil"],
                    occupants: this.$store.getters["generalLivingFormData/occupants"],
                    miles: this.$store.getters["generalLivingFormData/distance"],
                    mpg: this.$store.getters["generalLivingFormData/mpg"],
                    co2: this.$store.getters["generalLivingFormData/total_mt_co2"],
                    paypal_id: e.id,
                    payer_id: e.payer.payer_info.payer_id
                };

                if (this.$store.getters["user/isSet"]) {
                    options.user_id = await this.$store.getters["user/getItem"]("id");
                }
                console.log(options);
                axios.post(this.$store.getters["server"] + "/create-general-living-contribution", options)
                .then(() => {
                    this.$store.commit("generalLivingFormData/reset");
                    this.$router.push("/living/complete");
                });
            },
            async setup() {
                this.projectList = await axios.get(this.$store.getters["server"] + "/projects", {headers: {"Access-Control-Allow-Origin": this.$store.getters["server"]}})
                    .then((data) => {
                        console.log(data.data.projects);
                        return data.data.projects;
                    });
                this.showError = false;
                // this.setPaymentRecommended();
                // if (this.payment < this.payment_recommended) {
                //     this.payment = this.payment_recommended;
                // }
                // this.setPaymentAmount();
                this.calculations_done = true;
            },
            // Stop offset cost from wrapping by shrinking the text if it's too long
            getOffsetCostWrapScale() {
                let wrap = this.$refs.offsetCostWrap;
                if (wrap) {
                    let contentWidth = this.$refs.offsetCostIcon.offsetWidth + this.$refs.offsetCostText.offsetWidth;
                    if (contentWidth > wrap.offsetWidth) {
                        return wrap.offsetWidth / contentWidth * 0.8; // 0.8 is a buffer, because I can't include margins
                    }
                    return 1;
                }
                return 1;
            }
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../../assets/variables";

    #estimateExplanation{
        margin: 1.6em 0;
    }

    #calculatedValues {
        padding: 0 0 1rem;
        margin: 0 0 1rem;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    #calculatedOffsetCostWrap {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #calculatedOffsetIcon {
        font-size: 7.5rem;
        position: relative;

        .dollar-overlay {
            color: white;
            font-weight: 700;
            font-size: 0.47em;
            position: absolute;
            top: 30%;
            left: 36%;
        }
    }

    .calc-value{
        color: @text-color;
        font-size: 1.5rem;
        font-family: "Lora", serif;
        font-weight: 700;
    }

    #calculatedOffsetCost {
        text-align: left;
        position: relative;
        top: -0.5rem;
        margin-left: 1rem;
        font-size: 5rem;
    }

    #calculatedOffsetTotal {
        font-family: "Lora", serif;
        font-weight: 700;
    }

    #calculatedOffsetSubtitle{
        text-transform: uppercase;
        color: @light-gray;
        font-weight: bold;
        letter-spacing: 0.05em;
        font-size: 0.2em;
    }

    .calculated-item {
        .icon-caption {
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: @light-gray;
        }

        .co2-overlay {
            font-size: 1.2rem;
            color: white;
            position: absolute;
            width: 100%;
            top: 1.25em;
            text-align: center;
            font-weight: 700;
        }
    }

    .calculated-icon {
        text-align: center;
        font-size: 3.5rem;
        position: relative;
        color: @orange;
    }

    #notRecurring {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    img.nicc-icon {
        height: 1em;
    }
    #AboutButton {
        margin: 2rem auto ;
        padding: 0;
        max-width: 22em
    }

</style>



// WEBPACK FOOTER //
// src/components/general-living-calculator/GeneralLivingContribute.vue